// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2024project/q1/2024ncpsjds/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getAreas = (grade: string, forId: string) => {
  return http.get(`${urlPrefix}getAreas` + '&grade=' + grade + '&forId=' + forId);
};

const getRules = () => {
  return http.get(`${urlPrefix}rules`);
};

const saveinfo = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};
const saveCache = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save-cache`, qsData);
};
const saveInfoFirst = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save-first`, qsData);
};
const getInfoDetail = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}getcontent`, qsData);
};
const getUserList = (data: any) => {
  return http.get(`${urlPrefix}user-list` + '&unionid=' + data.unionid+"&page=" + data.page);
};
const deleteActive = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}deleteActive`, qsData);
};
const writeSendCode = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}writeSendCode`, qsData);
};

const getNews = (page: any, classId: any) => {
  return http.get(`/v1/news/topicList?page=${page}&classId=${classId}`);
};

export { getBaseInfo, getAreas, getRules, saveinfo,saveInfoFirst, getUserList,getInfoDetail, getNews,deleteActive, writeSendCode,saveCache };
